import React from 'react';

/**
 * Your own photo while your Portal is going up: still a SQUARE, with a progress stroke running
 * its edge. Handoff: handoff-composer/README.md "Posting indicators".
 *
 * The shape is the message. Round means live — the swirl ring only appears once the Portal is
 * actually up — so until then the photo stays square and nobody, including you, mistakes a
 * half-posted Portal for one your friends can see.
 */
export default function PostingRing({
  status = 'uploading',   // uploading | finishing | failed
  progress = 0,
  size = 64,
  avatarUrl = null,
  initial = '',
  showPercent = true,
}) {
  const failed = status === 'failed';
  const stroke = failed ? '#EF4444' : '#000000';
  const pct = Math.max(0, Math.min(100, Math.round(progress)));

  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <span
        className="absolute overflow-hidden border-2 border-black bg-black"
        style={{ inset: 7 }}
        aria-hidden
      >
        {avatarUrl
          ? <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
          : <span className="flex h-full w-full items-center justify-center font-mono font-bold text-white" style={{ fontSize: size * 0.3 }}>{(initial || '?').toUpperCase()}</span>}
        <span className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.45)' }} />
        {showPercent && !failed && (
          <span className="absolute inset-0 flex items-center justify-center font-mono font-bold text-white" style={{ fontSize: 11 }}>
            {pct}%
          </span>
        )}
      </span>

      {/* pathLength=100 makes the dash maths the percentage, whatever the size. */}
      <svg className="absolute inset-0" viewBox="0 0 100 100" width={size} height={size} aria-hidden>
        <rect x="2" y="2" width="96" height="96" fill="none" stroke="#E5E7EB" strokeWidth="3" />
        <rect
          x="2" y="2" width="96" height="96"
          fill="none"
          stroke={stroke}
          strokeWidth="3"
          pathLength="100"
          strokeDasharray={status === 'finishing' ? '14 86' : '100'}
          strokeDashoffset={status === 'finishing' ? 0 : 100 - pct}
          className={status === 'finishing' ? 'pr-posting-loop' : undefined}
          style={{ transition: status === 'finishing' ? undefined : 'stroke-dashoffset 140ms linear' }}
        />
      </svg>
    </div>
  );
}
